import { atom, withInit } from '@reatom/framework';

export type RunClub = '3cnl' | 'spaceship';

export const runClubModelAtom = atom<RunClub>('3cnl').pipe(
  withInit(() => {
    return typeof window !== 'undefined' &&
      window.location.hostname.includes('spaceship')
      ? 'spaceship'
      : '3cnl';
  }),
);
